import type { LiksDateDayRange } from './dateRangePicker';
import { LiksDateRangeDialogContent } from './LiksDateRangeDialogContent';

export type LiksDateRangeDialogProps = {
  isOpen: boolean;
  fromDay: string;
  toDay: string;
  onClose: () => void;
  onApply: (range: LiksDateDayRange | null) => void;
};

export function LiksDateRangeDialog({
  isOpen,
  fromDay,
  toDay,
  onClose,
  onApply,
}: LiksDateRangeDialogProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <LiksDateRangeDialogContent
      fromDay={fromDay}
      toDay={toDay}
      onClose={onClose}
      onApply={onApply}
    />
  );
}
